import { gql } from "urql"

export default gql`
  query AdminMatchedTutors($sourceUserId: ID!, $page: Int!) {
    student(id: $sourceUserId) {
      matchedUsers(page: $page) {
        totalPages
        currentPage
        data {
          id
          showPath
          fullName
          lastName
          tutorToStudentPhoneNumber(studentId: $sourceUserId)
          tutorToParentPhoneNumber(studentId: $sourceUserId)
          tutorToSecondaryParentPhoneNumber(studentId: $sourceUserId)
          studentToTutorPhoneNumber(studentId: $sourceUserId)
          parentToTutorPhoneNumber(studentId: $sourceUserId)
          secondaryParentToTutorPhoneNumber(studentId: $sourceUserId)
        }
      }
    }
  }
`
